module.exports = __webpack_public_path__ + "ArrowBack/ArrowBack-bd0bab381a9479cae35045fa96580a50.svg";